module.exports = __webpack_public_path__ + "static/media/Pancreas.64594460.ogg";